import { useModulePermission } from '../../../hooks/usePermission';
import { Modules } from '../../../constants/permissions';

/**
 * SC 模組權限 hook
 *
 * 基於 pgCode = "C2021"（SYS_Program 中的銷售合約程式代碼）
 * 權限格式: C2021_QUERY, C2021_ADD, C2021_EDIT, C2021_DELETE, C2021_EXPORT, C2021_PRINT
 *
 * 這是黃金範例，後續模組照搬此模式：
 *   import { useModulePermission } from '../../../hooks/usePermission';
 *   import { Modules } from '../../../constants/permissions';
 *   const perms = useModulePermission(Modules.YOUR_MODULE);
 */
export function useSCPermissions() {
  return useModulePermission(Modules.SALES_CONTRACT);
}
